export const translations = {
  locale: "ru",
  values: [
    { messageId: "ux-common-filter-hide-filters", text: "Скрыть неактивные" },
    { messageId: "ux-common-filter-button-search", text: "Поиск" },
    { messageId: "ux-common-filter-show-filters", text: "Показать все" },
    { messageId: "ux-common-button-ok", text: "OK" },
    { messageId: "ux-common-link-cancel", text: "Отмена" },
    { messageId: "ux-common-picker-chip-more", text: "{count, number} еще" },
    { messageId: "ux-common-picker-newSearch", text: "Введите запрос" },
    { messageId: "ux-common-picker-advancedSearch", text: "Расширеный поиск" },
    { messageId: "ux-common-picker-searchAllWords", text: "По всем словам" },
    { messageId: "ux-common-picker-searchExactWords", text: "Точное совпадение" },
    { messageId: "ux-common-picker-searchAnyWords", text: "Любое из слов" },
    { messageId: "ux-common-picker-searchNoneWords", text: "Ни одно из слов" },
    { messageId: "ux-common-picker-searchStartsWith", text: "По началу" },
    { messageId: "ux-common-picker-searchEndsWith", text: "По окончанию" },
    { messageId: "ux-common-picker-searchWithin", text: "По локальному списку" },
    { messageId: "ux-common-picker-searchIn", text: "Поиск" },
    { messageId: "ux-common-picker-refineSearch", text: "Ничего не найдено. Пожалуйста, уточните критерии поиска и попробуйте снова" },
    { messageId: "ux-common-picker-startSearch", text: "Введите критерии." },
    { messageId: "ux-common-picker-foundText", text: "{count, number} элементов найдено:" },
    { messageId: "ux-common-picker-allItemsShown", text: "Всего отображено" },
    { messageId: "ux-common-picker-currentSelection", text: "Текущий элемент" },
    { messageId: "ux-common-picker-selectFromItemsBelow", text: "Выберите из элементов ниже" },

    { messageId: "paris-common-action-chooseLanguage", text: "Выбрать язык" },
    { messageId: "paris-common-action-signIn", text: "Войти" },
    { messageId: "paris-common-action-signout", text: "Выйти" },
    { messageId: "paris-common-action-settingsScreen", text: "Настройки" },

    { messageId: "paris-common-error-invalidSession", text: "Пользователь вышел из системы или его сессия истекла." },
    { messageId: "paris-common-error-loadLocalesFailed", text: "Невозможно загрузить список доступных локалей." },
    { messageId: "paris-common-error-loadSearchedLocales", text: "Поиск локалей не может быть выполнен." },
    { messageId: "paris-common-error-localeNotSupported", text: "Локаль не поддерживается." },
    { messageId: "paris-common-error-authenticationFailed", text: "Неудается выполнить вход. Пожалуйста. попробуйте снова или свяжитесь со службой поддержки." },
    { messageId: "paris-common-error-authorizationFailed", text: "Не удается авторизоваться. Пожалуйста. попробуйте снова или свяжитесь со службой поддержки." },

    { messageId: "paris-common-heading-languageCaption", text: "Язык" },
    { messageId: "paris-common-heading-themeCaption", text: "Тема" },
    { messageId: "paris-common-heading-chooseLanguageField", text: "Язык" },

    { messageId: "paris-common-info-signInProcessing", text: "аутентификация..." },
    { messageId: "paris-common-info-authorizationProcessing", text: "авторизация..." },
    { messageId: "paris-common-info-emptyText", text: "Ничего не найдено." },

    { messageId: "paris-common-property-date", text: "Дата" },
    { messageId: "paris-common-property-author", text: "Автор" },
    { messageId: "paris-common-property-language", text: "Язык" },
    { messageId: "paris-common-property-industry", text: "Индустрия" },
    { messageId: "paris-common-property-action", text: "Действие" },
    { messageId: "paris-common-property-translation", text: "Перевод" },
    { messageId: "paris-common-property-definition", text: "Определение" },
    { messageId: "paris-common-property-history", text: "История" },
    { messageId: "paris-common-property-term", text: "Терм" },
    { messageId: "paris-common-property-description", text: "Описание" },
    { messageId: "paris-common-property-source", text: "Источник" },
    { messageId: "paris-common-property-status", text: "Статус" },

    { messageId: "paris-common-title-plexDictionary", text: "PLEX Словарь" },
    { messageId: "paris-common-title-plexDictionaryTranslationManager", text: "Менеджер переводов" },
    { messageId: "paris-common-title-termTranslationsHistory", text: "История переводов" },
    { messageId: "paris-common-title-notFoundScreen", text: "Не найдено" },
    { messageId: "paris-common-title-settingsScreen", text: "Настройки" },
    { messageId: "paris-common-title-termsGroup", text: "Термы" },
    { messageId: "paris-common-title-signedIn", text: "Вход" },
    { messageId: "paris-common-title-signIn", text: "Войти" },
    { messageId: "paris-common-title-errorApp", text: "Ошибка" },
    { messageId: "paris-common-title-termTranslations", text: "Переводы терма" },
    { messageId: "paris-common-title-chooseLanguage", text: "Выбрать язык" },
    { messageId: "paris-common-title-chooseLanguagePicker", text: "Список языков" },

    { messageId: "paris-glossary-option-termTranslationStatusInReview", text: "Ревью" },
    { messageId: "paris-glossary-option-termTranslationStatusApproved", text: "Одобрено" },
    { messageId: "paris-glossary-option-termTranslationSourcePlex", text: "Plex" },
    { messageId: "paris-glossary-option-termTranslationSourceMachine", text: "Авто" }
  ]
};
